@if (columnFilters && filterColumns.length) {
  <!-- Bajo `md` la barra se pliega a una hoja inferior con los MISMOS nodos: el
       botón «Filtros» de la barra de herramientas la abre (`.is-open`), y el pie
       solo existe en la hoja. En escritorio nada de esto se monta. -->
  @if (compact() && filtersOpen) {
    <div class="dxc-scrim dxc-scrim--sheet is-open" aria-hidden="true" (click)="toggleFilters(false)"></div>
  }
  <div class="dxc-filterbar" [class.is-open]="compact() && filtersOpen"
    [attr.role]="compact() && filtersOpen ? 'dialog' : null"
    [attr.aria-label]="compact() && filtersOpen ? 'Filtros' : null">
    @for (column of filterColumns; track column.key) {
      <div class="dxc-field">
        <label class="dxc-field__label" [attr.for]="'filter-' + column.key">{{ column.label }}</label>
        @if (column.filter === 'select') {
          <!-- panelWidth="auto": la barra de filtros comprime sus campos para caber
               en una sola fila, así que un catálogo de texto largo — «Camión
               Unitario <=3.5 toneladas» — sale recortado dentro del campo. El
               panel crece a lo que pida la opción más larga; el campo no. -->
          <dxc-select [selectId]="'filter-' + column.key" [options]="filterOptions(column)"
            [searchable]="filterOptions(column).length > 8" placeholder="Todos"
            panelWidth="auto"
            [value]="filters[column.key] || ''" (valueChange)="setFilter(column.key, $event)"></dxc-select>
        } @else {
          <input class="dxc-input" [id]="'filter-' + column.key" [placeholder]="'Filtrar por ' + column.label.toLowerCase()"
            [value]="filters[column.key] || ''" (input)="setFilter(column.key, $any($event.target).value)">
        }
      </div>
    }
    @if (compact()) {
      <div class="dxc-filterbar__foot dxc-savebar dxc-savebar--stack">
        <button type="button" class="dxc-btn dxc-btn--primary" (click)="toggleFilters(false)">
          Ver {{ filteredRows.length }} {{ itemLabel }}
        </button>
        @if (activeFilters.length) {
          <button type="button" class="dxc-btn dxc-btn--secondary" (click)="clearFilters()">Limpiar filtros</button>
        }
      </div>
    }
  </div>

  @if (activeFilters.length) {
    <div class="dxc-filterbar__active">
      <span class="dxc-filterbar__legend">Filtros aplicados</span>
      @for (filter of activeFilters; track filter.key) {
        <span class="dxc-chip" [title]="filter.label + ': ' + filter.value">
          <span>{{ filter.label }}: {{ filter.value }}</span>
          <button type="button" [attr.aria-label]="'Quitar el filtro de ' + filter.label"
            (click)="clearFilter(filter.key)">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg>
          </button>
        </span>
      }
      <button type="button" class="dxc-btn dxc-btn--ghost dxc-btn--sm" (click)="clearFilters()">Limpiar filtros</button>
    </div>
  }
}

@if (searchable || toolbarExtra || (compact() && filterColumns.length)) {
  <div class="dxc-toolbar">
    @if (searchable) {
      <div class="dxc-toolbar__search">
        <span class="dxc-field__icon dxc-field__icon--left">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
            <circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/>
          </svg>
        </span>
        <input class="dxc-input dxc-input--with-icon" [placeholder]="searchPlaceholder"
          [value]="query" (input)="onSearch($any($event.target).value)" aria-label="Buscar">
      </div>
    }
    @if (compact() && filterColumns.length) {
      <button type="button" class="dxc-btn dxc-btn--neutral dxc-btn--sm dxc-filterbar__toggle"
        [attr.aria-expanded]="filtersOpen" (click)="toggleFilters()">
        <dxc-icon name="filtro"></dxc-icon>
        Filtros{{ activeFilters.length ? ' · ' + activeFilters.length : '' }}
      </button>
    }
    <div class="dxc-toolbar__spacer"></div>
    <ng-content select="[toolbar]"></ng-content>
  </div>
}

@if (selectable && selection.length) {
  <div class="dxc-bulkbar">
    <span>{{ selection.length }} {{ itemGender === 'm' ? 'seleccionado' : 'seleccionada' }}{{ selection.length > 1 ? 's' : '' }}</span>
    <button type="button" class="dxc-btn dxc-btn--ghost dxc-btn--sm" (click)="clearSelection()">Quitar selección</button>
    <div class="dxc-toolbar__spacer"></div>
    <ng-content select="[bulk]"></ng-content>
  </div>
}

@if (loading) {
  <!-- Se carga la forma del contenido, no un spinner centrado: así no salta el
       layout cuando llegan los datos. -->
  <div style="padding:20px;display:flex;flex-direction:column;gap:14px">
    @for (row of skeletonRows; track $index) {
      <div style="display:flex;gap:14px">
        @for (column of columns; track column.key) { <div class="dxc-skel" style="flex:1"></div> }
      </div>
    }
  </div>
} @else if (!pageRows.length) {
  <div class="dxc-empty">
    <div class="dxc-empty__icon">
      <ng-content select="[empty-icon]"></ng-content>
    </div>
    <h4>{{ query.trim() ? emptySearchTitle + ' «' + query.trim() + '»' : (hasCriteria ? 'Ningún resultado coincide con los filtros' : emptyTitle) }}</h4>
    @if (hasCriteria) {
      <p>Prueba con menos criterios o límpialos para ver todo de nuevo.</p>
      <button type="button" class="dxc-btn dxc-btn--neutral" (click)="clearCriteria()">
        {{ activeFilters.length ? 'Limpiar filtros' : 'Limpiar búsqueda' }}
      </button>
    } @else {
      @if (emptyMessage) { <p>{{ emptyMessage }}</p> }
      <ng-content select="[empty-action]"></ng-content>
    }
  </div>
} @else {
  <div class="dxc-table-wrap" dxcScrollHint dxcScrollHintBelow="lg">
    <table class="dxc-table" [class.dxc-table--fixed]="fixedLayout" [class.dxc-table--stack]="stack">
      <thead>
        <tr>
          @if (selectable) {
            <th class="sel">
              <input type="checkbox" [checked]="allOnPageSelected" (change)="toggleAllOnPage()"
                aria-label="Seleccionar la página">
            </th>
          }
          @for (column of columns; track column.key) {
            <th [class.num]="column.align === 'right'" [class.is-sortable]="column.sortable"
              [class.is-truncate]="column.truncate"
              [attr.aria-sort]="sortAttr(column.key)" [attr.tabindex]="column.sortable ? 0 : null"
              [attr.role]="column.sortable ? 'button' : null" [style.width]="column.width || null"
              (click)="column.sortable && onSort(column.key)"
              (keydown)="column.sortable && onHeaderKey($event, column.key)">
              {{ column.label }}
              @if (column.sortable) {
                <svg width="12" height="12" class="sort" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                     stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m8 7 4-4 4 4M8 17l4 4 4-4"/></svg>
              }
            </th>
          }
          @if (hasActions) { <th class="actions">Acciones</th> }
        </tr>
      </thead>
      <tbody>
        @for (row of pageRows; track trackRow(row)) {
          <tr [attr.aria-selected]="isSelected(row) ? true : null"
            [attr.data-dxc-rail]="rowRail(row)">
            @if (selectable) {
              <td class="sel">
                <input type="checkbox" [checked]="isSelected(row)" (change)="toggleRow(row)"
                  [attr.aria-label]="'Seleccionar ' + cellText(columns[0], row)">
              </td>
            }
            @for (column of columns; track column.key) {
              <td [class.num]="column.align === 'right'" [class.mono]="column.mono && !!cellText(column, row)"
                [class.is-truncate]="column.truncate"
                [attr.data-label]="column.label" [attr.data-stack]="stackRole(column)">
                @if (column.status) {
                  @if (column.status(row); as badge) {
                    <span class="dxc-badge" [class]="'dxc-badge dxc-badge--' + badge.variant"
                      [class.dxc-badge--quiet]="isQuietBadge(column)"
                      [attr.title]="badge.title || null">
                      {{ badge.label }}
                    </span>
                  }
                } @else if (column.avatar) {
                  @if (column.avatar(row); as who) {
                    <span class="dxc-user">
                      <span class="dxc-avatar dxc-avatar--soft">
                        @if (who.url) { <img [src]="who.url" alt=""> } @else { {{ who.initials }} }
                      </span>
                      <span class="dxc-user__body">
                        <span class="dxc-user__name">{{ cellText(column, row) }}</span>
                        @if (column.muted && column.muted(row)) {
                          <span class="dxc-user__role">{{ column.muted(row) }}</span>
                        }
                      </span>
                    </span>
                  }
                } @else if (column.code || column.truncate) {
                  <!-- Identificador + texto en una sola celda, y en una sola
                       línea si la columna lo pide: el `title` lleva lo que se
                       cortó, que es la única forma de leerlo. -->
                  @if (cellFull(column, row); as full) {
                    <span [class.dxc-table__clip]="column.truncate" [attr.title]="column.truncate ? full : null">@if (cellCode(column, row)) {<span class="dxc-mono">{{ cellCode(column, row) }}</span>}{{ cellCode(column, row) && cellText(column, row) ? ' · ' : '' }}{{ cellText(column, row) }}</span>
                  } @else {
                    <span class="dxc-muted">—</span>
                  }
                } @else {
                  <!-- Un dato que falta se resuelve con un guion largo apagado,
                       igual que en `.dxc-facts`. Y fuera de la familia mono: el
                       guion no es un identificador, y en mono sale más corto que
                       el de la celda de al lado — dos ausencias en la misma fila
                       se leían como dos cosas distintas. -->
                  @if (cellText(column, row)) {
                    {{ cellText(column, row) }}
                  } @else if (!column.muted || !column.muted(row)) {
                    <span class="dxc-muted">—</span>
                  }
                  @if (column.muted && column.muted(row)) {
                    <span class="muted">{{ column.muted(row) }}</span>
                  }
                }
              </td>
            }
            @if (hasActions) {
              <td class="actions" data-label="Acciones">
                @for (action of actions; track action.action) {
                  @if (action.hidden?.(row)) {
                    <span class="dxc-btn dxc-btn--icon dxc-btn--sm dxc-table__action-slot" aria-hidden="true"><dxc-icon [name]="action.icon"></dxc-icon></span>
                  } @else {
                    <button type="button" class="dxc-btn dxc-btn--icon dxc-btn--sm"
                      [class.dxc-btn--ghost]="!action.danger" [class.dxc-btn--danger-ghost]="action.danger"
                      [attr.aria-label]="action.label + ' ' + cellText(columns[0], row)"
                      (click)="rowAction.emit({ action: action.action, row })">
                      <dxc-icon [name]="action.icon"></dxc-icon>
                    </button>
                  }
                }
              </td>
            }
          </tr>
        }
      </tbody>
    </table>
  </div>

  @if (totalPages > 1 || showCount) {
    <div class="dxc-table__foot">
      <span>Mostrando <b style="color:var(--dxc-text);font-variant-numeric:tabular-nums">{{ rangeFrom }}–{{ rangeTo }}</b>
        de <b style="color:var(--dxc-text);font-variant-numeric:tabular-nums">{{ filteredRows.length }}</b> {{ itemLabel }}</span>
      @if (totalPages > 1) {
        <div class="dxc-pager">
          <button type="button" [disabled]="page === 1" aria-label="Anterior" (click)="goTo(page - 1)">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m15 18-6-6 6-6"/></svg>
          </button>
          @for (n of pageNumbers; track n) {
            <button type="button" [attr.aria-current]="n === page ? 'page' : null" (click)="goTo(n)">{{ n }}</button>
          }
          <button type="button" [disabled]="page === totalPages" aria-label="Siguiente" (click)="goTo(page + 1)">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg>
          </button>
        </div>
      }
    </div>
  }
}
